// extracted by mini-css-extract-plugin
export default {"messageContainer":"messageContainer___urKT1"};